module.exports = __webpack_public_path__ + "img/bloom_dark_brown_ba_list.3982dc33.jpg";